module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Bold.d41d362.eot";